<ion-button (click)="onAuthIconBtnClicked($event)" style="font-size: inherit; color: inherit; height: 50px; --color: inherit;">
  <ion-spinner *ngIf="mediasDownloadProgress.isDownloading" name="crescent" style="position: absolute; width: 45px; height: 45px;"></ion-spinner>
  <div class="auth-icon-container">
    <ion-icon *ngIf="!userProfilePhotoSrc" style="font-size: inherit; color: inherit;" slot="icon-only" [attr.name]="(userService.isImpersonating$ | async) ? 'people' : 'person-sharp'"></ion-icon>
    <!-- TODO: Usar bloco abaixo quando tivermos fotos de perfil -->
    <!-- <div *ngIf="userProfilePhotoSrc" style="border-radius: 50%; overflow: hidden;">
      <app-img
      style="width: 35px; height: 35px; display: block;"
        [src]="userProfilePhotoSrc"
        [name]="userProfilePhotoName"
        [width]="35"
        [height]="35">
      </app-img>
    </div> -->
    <div class="auth-icon-dot" [ngStyle]="{'background': authService.isLoggedIn ? 'rgb(0 185 35)' : '#FF645B'}"></div>
  </div>
</ion-button>
<!-- <div style="display: inline; position: absolute; left: 55%;">
  <ion-badge *ngIf="userService.newContactsCount + invitesService.invitesRequestsCount" class="app-badge">{{ userService.newContactsCount + invitesService.invitesRequestsCount }}</ion-badge>
</div> -->
